import * as React from "react"
import { ContextMenu as BaseContextMenu } from "@base-ui/react/context-menu"
import { Menu } from "./Menu"

/**
 * ContextMenu — right-click menu. Reuses <Menu.*> styled parts for items.
 *
 * Usage:
 *   <ContextMenu.Root>
 *     <ContextMenu.Trigger render={<div />}>...</ContextMenu.Trigger>
 *     <ContextMenu.Content>
 *       <Menu.Item>Copy</Menu.Item>
 *       ...
 *     </ContextMenu.Content>
 *   </ContextMenu.Root>
 */
const Root = BaseContextMenu.Root
const Trigger = BaseContextMenu.Trigger

const Content = Menu.Content

export const ContextMenu = { Root, Trigger, Content }
